import { Box } from 'dash-ui';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  border-radius: ${({ theme }) => theme.space}px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};

  @media ${({ theme }) => theme.devices.tablet} {
    p,
    a {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    box-shadow: none;
  }
`;

export const ButtonsWrapper = styled(Wrapper)`
  @media ${({ theme }) => theme.devices.mobile} {
    position: fixed;
    bottom: 56px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    width: 100%;
    left: 0;
    z-index: 4;
  }
`;

export const ContainerWrapper = styled(Box)`
  top: 107px;
`;
